// extracted by mini-css-extract-plugin
export default {"video":"video_video__NFqsL","playBtn":"video_playBtn__yIJma","isPlaying":"video_isPlaying__lV9wo"};